// @flow

export function pushGTM(event: string) {
  if (window.dataLayer && process.env.NODE_ENV === 'production') {
    window.dataLayer.push({ event });
  } else if (process.env.NODE_ENV === 'development') {
    console.log('DEV : Report to GTM', { event });
  }
}
